export const hashCode = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

export const intToRGB = (i: number) => {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();
  return '00000'.substring(0, 6 - c.length) + c;
};

export const generateColorFromName = (name: string) => {
  const generateLighterColor = (color: string) => {
    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);

    const lighterR = Math.round((r + 255) / 2.2);
    const lighterG = Math.round((g + 255) / 2.2);
    const lighterB = Math.round((b + 255) / 2.2);

    const lighterColor =
      '#' +
      lighterR.toString(16).padStart(2, '0') +
      lighterG.toString(16).padStart(2, '0') +
      lighterB.toString(16).padStart(2, '0');

    return lighterColor;
  };
  const primaryHash = hashCode(name);
  const secondaryHash = hashCode(name + 'secondary');
  const tertiaryHash = primaryHash ^ secondaryHash;
  let color = '#' + intToRGB(tertiaryHash);

  // Get a lighter version of the color
  const lighterColor = generateLighterColor(color);

  return lighterColor;
};

export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

// Function to lighten a color
export const lightenColor = (hex: string, percent: number) => {
  const rgb = hexToRgb(hex);
  if (!rgb) {
    return hex;
  }
  const factor = percent / 100;

  const r = Math.round(rgb.r + (255 - rgb.r) * factor);
  const g = Math.round(rgb.g + (255 - rgb.g) * factor);
  const b = Math.round(rgb.b + (255 - rgb.b) * factor);

  return rgbToHex(Math.min(255, r), Math.min(255, g), Math.min(255, b));
};

// Function to darken a color
export const darkenColor = (hex: string, percent: number) => {
  const rgb = hexToRgb(hex);
  if (!rgb) {
    return hex;
  }
  const factor = percent / 100;

  const r = Math.round(rgb.r * (1 - factor));
  const g = Math.round(rgb.g * (1 - factor));
  const b = Math.round(rgb.b * (1 - factor));

  return rgbToHex(r, g, b);
};
